import './App.css';
import Navbar from './components/Navbar';
import Memes from './components/Memes';


function App() {
  return (
    <div className="App">
      <Navbar/>
      <Memes/>
    </div>
  );
}

export default App;
